export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_EMPLOYEE = 'ROLE_EMPLOYEE';
export const ROLE_HR = 'ROLE_HR';
export const ROLE_CONTENT_MANAGER = 'ROLE_CONTENT_MANAGER';
export const ROLE_OPERATIONAL_MANAGER = 'ROLE_OPERATIONAL_MANAGER';